import React from 'react';
import { Printer } from 'lucide-react';
import { DailyDataResponse } from '../types';
import { DailyChartComponent } from './DailyChartComponent';
import { formatUTCTime } from '../utils';

type DailyDataViewProps = {
  data: DailyDataResponse;
};

export const DailyDataView: React.FC<DailyDataViewProps> = ({ data }) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="flex-1 p-6 overflow-y-auto">
      <div className="max-w-7xl mx-auto">
        {/* 印刷ボタン */}
        <div className="no-print mb-4 flex justify-end">
          <button
            onClick={handlePrint}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Printer className="w-5 h-5" />
            印刷
          </button>
        </div>

        {/* 上部の情報表示 */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-6 print-avoid-break print-header">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
            <div>
              <p className="text-sm text-gray-500">ユーザID</p>
              <p className="font-semibold">{data.user_id}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">選択した日</p>
              <p className="font-semibold">{data.created_at.split('T')[0]}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">睡眠スコア</p>
              <p className="font-semibold">{data.sleep_score}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">睡眠時間</p>
              <p className="font-semibold">{data.sleep_time}分</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">睡眠効率</p>
              <p className="font-semibold">{(data.sleep_efficiency * 100).toFixed(1)}%</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">入眠時刻</p>
              <p className="font-semibold">{formatUTCTime(data.sleep_in_time)}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">起床時刻</p>
              <p className="font-semibold">{formatUTCTime(data.wake_up_time)}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">計測時間</p>
              <p className="font-semibold text-xs">
                {formatUTCTime(data.start_time)} - 
                {formatUTCTime(data.end_time)}
              </p>
            </div>
          </div>
        </div>

        {/* グラフ表示 */}
        <div className="print-avoid-break">
          <DailyChartComponent data={data} />
        </div>
      </div>
    </div>
  );
};
